import { makeWorkbook } from "../../utils/excel";
import {
  getIndicatorCandidatureChangesByState,
  getIndicatorCandidatureChangesByType,
} from "../../../../../../rest/indicator";

const FALLBACK_LABELS = {
  APPROVED: "Aprovada",
  VALIDATION: "A aguardar decisão do IEFP",
  WAIT_CONTESTATION: "Em audiência prévia",
  CONTESTATION_ANALYSIS: "Em análise de audiência prévia",
  REJECTED: "Indeferida",
  WAIT_TERM_ACCEPT_SUBMISSION: "A aguardar Termo de Aceitação",
  NIB: "NIB",
  POSTOS_TRABALHO: "Postos de trabalho",
  FINANCIAMENTO: "Investimento",
};

const pctFrac = (v, t) => (t > 0 ? Number(v) / Number(t) : 0);

function normalizeResponse(resp) {
  const p = resp?.data ?? {};
  const rows = Array.isArray(p) ? p : (p.data ?? []);
  return rows.map((r) => ({
    code: r?.code ?? "-",
    counter: Number(r?.counter || 0),
  }));
}

export async function buildWorkbookApplicationChanges(opts = {}) {
  const { intl } = opts;

  const [resStates, resTypes] = await Promise.all([
    getIndicatorCandidatureChangesByState(),
    getIndicatorCandidatureChangesByType(),
  ]);

  const states = normalizeResponse(resStates).sort(
    (a, b) => b.counter - a.counter || String(a.code).localeCompare(String(b.code))
  );
  const types = normalizeResponse(resTypes).sort(
    (a, b) => b.counter - a.counter || String(a.code).localeCompare(String(b.code))
  );

  const totalStates = states.reduce((s, r) => s + r.counter, 0);
  const totalTypes  = types.reduce((s, r) => s + r.counter, 0);

  const L = {
    estados: intl
      ? intl.formatMessage({ id: "indicator.changes.state", defaultMessage: "Estados" })
      : "Estados",
    tipos: intl
      ? intl.formatMessage({ id: "indicator.changes.type", defaultMessage: "Tipos" })
      : "Tipos",
    total: intl
      ? intl.formatMessage({ id: "indicator.total", defaultMessage: "Total" })
      : "Total",
  };

  const labelState = (code) =>
    intl
      ? intl.formatMessage({
          id: `indicator.state.${code}`,
          defaultMessage: FALLBACK_LABELS[code] || code,
        })
      : (FALLBACK_LABELS[code] || code);

  const labelType = (code) =>
    intl
      ? intl.formatMessage({
          id: `indicator.changeType.${code}`,
          defaultMessage: FALLBACK_LABELS[code] || code,
        })
      : (FALLBACK_LABELS[code] || code);

  const resumoAoa = [
    ["Indicador", "Valor"],
    [L.estados, Number(totalStates || 0)],
    [L.tipos,   Number(totalTypes  || 0)],
  ];

  const estadosAoa = [
    [L.estados, L.total, "% do total"],
    ...states.map((r) => [labelState(r.code), r.counter, pctFrac(r.counter, totalStates)]),
  ];

  const tiposAoa = [
    [L.tipos, L.total, "% do total"],
    ...types.map((r) => [labelType(r.code), r.counter, pctFrac(r.counter, totalTypes)]),
  ];

  return makeWorkbook([
    { name: "Resumo",  aoa: resumoAoa },
    { name: "Estados", aoa: estadosAoa, percentCols: [2] },
    { name: "Tipos",   aoa: tiposAoa,   percentCols: [2] },
  ]);
}
